import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import { GenericModal } from "@Shared/components/modals";
import CheckboxSection from "@Shared/components/sections/checkbox-section.vue";
import CoBrokerSearchStep from "./co-broker/co-broker-search-step.vue";
import CoBrokerConfirmationStep from "./co-broker/co-broker-confirmation-step.vue";
import CardRadioField from "@Shared/components/form-elements/fields/card-radio-field.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { computed, defineComponent, ref, toRefs, watchEffect } from "@vue/composition-api";
import { useApplicationStoreActions, useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import * as ApplicationActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import Amplitude from "@Shared/@Utils/amplitude";
import { useI18n } from "vue-i18n-composable";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { fullName } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "CoBrokerModal",
  components: {
    GenericModal,
    SimpleButton,
    CheckboxSection,
    CoBrokerSearchStep,
    CoBrokerConfirmationStep,
    CardRadioField,
    InlinePrompt
  },
  mixins: [validationMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  validations: {
    mortgagesSelected: {
      required
    },
    data: {
      agentFirstName: {
        required,
        minLength: minLength(2)
      },
      agentLastName: {
        required,
        minLength: minLength(2)
      },
      agentSelected: {
        agentUsername: {
          required
        }
      }
    }
  },
  setup(props) {
    const {
      CO_BROKER_APPLICATION,
      UPDATE_CO_BROKERED_MORTGAGE,
      SAVE_CURRENT_APPLICATION
    } = useApplicationStoreActions([LenderSubmitActions.CO_BROKER_APPLICATION, LenderSubmitActions.UPDATE_CO_BROKERED_MORTGAGE, ApplicationActions.SAVE_CURRENT_APPLICATION]);
    const {
      REQUESTED_MORTGAGES_DETAILS
    } = useApplicationStoreGetters([ApplicationGetters.REQUESTED_MORTGAGES_DETAILS]);
    const {
      CURRENT_USER_DETAILS,
      CURRENT_BROKERAGE_DETAILS
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_DETAILS, AccountGetters.CURRENT_BROKERAGE_DETAILS]);
    const {
      IS_MORTGAGE_CO_BROKERED
    } = useApplicationStoreGetters([LenderSubmitGetters.IS_MORTGAGE_CO_BROKERED]);
    const {
      clientUsername,
      applicationId
    } = toRefs(props);
    const {
      v$
    } = useVuelidate();
    const {
      t,
      tc
    } = useI18n();
    const stepRef = ref();
    const showAgentsTable = ref(false);
    const showFavorites = ref(false);
    const submitButtonLoader = ref(false);
    const emptyData = ref({
      agentFirstName: "",
      agentLastName: "",
      agentSelected: {},
      brokerageSelected: {},
      newAgentValue: "",
      existingAgentValue: "",
      referralValue: "",
      consentChecked: false
    });
    const data = ref(emptyData.value);
    const mortgagesSelected = ref([]);
    const steps = ref(["search", "confirmation"]);
    const currentStepIndex = ref(0);
    const coBrokerModal = ref(null);
    const currentStep = computed(() => steps.value[currentStepIndex.value]);
    const isConfirmationStep = computed(() => currentStep.value === "confirmation");
    const currentStepComponent = computed(() => `co-broker-${currentStep.value}-step`);
    const requestedMortgageDetailsWithType = computed(() => REQUESTED_MORTGAGES_DETAILS.value);
    const brokerDetails = computed(() => CURRENT_USER_DETAILS.value);
    const brokerageDetails = computed(() => CURRENT_BROKERAGE_DETAILS.value.tiedBrokerages[0]);
    const handleShow = () => {
      if (requestedMortgageDetailsWithType.value.length === 1) {
        var _context;
        const [firstRequestedMortgage] = requestedMortgageDetailsWithType.value;
        mortgagesSelected.value = _concatInstanceProperty(_context = []).call(_context, firstRequestedMortgage.type);
      }
      Amplitude.logEvent(`Participants - co brokering modal opened`, {
        page: "participants",
        subpage: "co-brokering"
      });
    };
    const handleClearData = () => {
      currentStepIndex.value = 0;
      mortgagesSelected.value = [];
      data.value = emptyData.value;
      if (stepRef.value && stepRef.value.resetData) stepRef.value.resetData();
      showAgentsTable.value = false;
    };
    const modalDescriptionToShow = computed(() => {
      return currentStepIndex.value === 0 ? tc("direct-to-lender.participants.coBrokerModalDescription", requestedMortgageDetailsWithType.value.length) : tc("direct-to-lender.participants.coBrokerSecondStepDescription", requestedMortgageDetailsWithType.value.length);
    });
    const isMortgageSelected = mortgageType => {
      var _context2;
      return _includesInstanceProperty(_context2 = mortgagesSelected.value).call(_context2, mortgageType);
    };
    const handleSelectMortgage = mortgageType => {
      if (isMortgageSelected(mortgageType)) {
        var _context3;
        mortgagesSelected.value = _filterInstanceProperty(_context3 = mortgagesSelected.value).call(_context3, mortgage => mortgage !== mortgageType);
      } else mortgagesSelected.value.push(mortgageType);
    };
    const handleSubmit = async () => {
      submitButtonLoader.value = true;
      const {
        succeeded
      } = await CO_BROKER_APPLICATION({
        cobrokerUsername: data.value.agentSelected.agentUsername,
        mortgages: mortgagesSelected.value,
        brokerName: fullName(brokerDetails.value),
        brokerageName: brokerageDetails.value.name,
        clientUsername: clientUsername.value,
        applicationId: applicationId.value
      });
      if (succeeded) updateCoBrokeredMortgages();
      submitButtonLoader.value = false;
      coBrokerModal.value.hide();
    };
    const showPreviousStep = computed(() => !!steps.value[currentStepIndex.value - 1]);
    const isValid = computed(() => {
      var _v$$value;
      return !((_v$$value = v$.value) != null && _v$$value.$invalid) || showFavorites.value && data.value.agentSelected.agentUsername;
    });
    const submitButtonValidation = computed(() => data.value.consentChecked);
    const handleChangeData = newData => {
      data.value = _objectSpread(_objectSpread({}, data.value), newData);
    };
    const handleSearchAgent = async () => {
      showAgentsTable.value = true;
    };
    const handleShowFavorites = async () => {
      showAgentsTable.value = true;
      showFavorites.value = true;
    };
    const handleNextStep = () => currentStepIndex.value++;
    const handlePreviousStep = () => currentStepIndex.value--;
    const firstNameIsValid = computed(() => {
      var _v$$value$data;
      return !((_v$$value$data = v$.value.data) != null && _v$$value$data.agentFirstName.$invalid);
    });
    const lastNameIsValid = computed(() => {
      var _v$$value$data2;
      return !((_v$$value$data2 = v$.value.data) != null && _v$$value$data2.agentLastName.$invalid);
    });
    const agentFullNameIsValid = computed(() => firstNameIsValid.value && lastNameIsValid.value);
    const updateCoBrokeredMortgages = () => {
      mortgagesSelected.value.forEach(mortgageType => {
        const mortgageToUpdate = {
          type: mortgageType,
          index: MORTGAGE_TYPE_PARSER[mortgageType],
          refiAdditionalInfo: t("direct-to-lender.participants.coBrokeredMortgageDescription", {
            coBrokeredTo: IS_MORTGAGE_CO_BROKERED.value(mortgageType),
            brokerage: data.value.agentSelected.brokerageName
          })
        };
        UPDATE_CO_BROKERED_MORTGAGE(mortgageToUpdate);
      });
      SAVE_CURRENT_APPLICATION({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        reFetchCalculations: true
      });
    };
    watchEffect(() => {
      const {
        agentFirstName,
        agentLastName
      } = data.value;
      if (!agentFirstName && !agentLastName && showAgentsTable.value && !showFavorites.value) {
        showAgentsTable.value = false;
      }
    });
    return {
      handleShow,
      handleClearData,
      isMortgageSelected,
      handleSelectMortgage,
      handleNextStep,
      handlePreviousStep,
      handleChangeData,
      handleSearchAgent,
      handleSubmit,
      submitButtonValidation,
      coBrokerModal,
      isConfirmationStep,
      submitButtonLoader,
      stepRef,
      isValid,
      showPreviousStep,
      mortgagesSelected,
      currentStepComponent,
      requestedMortgageDetailsWithType,
      modalDescriptionToShow,
      REQUESTED_MORTGAGES_DETAILS,
      IS_MORTGAGE_CO_BROKERED,
      data,
      currentStepIndex,
      currentStep,
      firstNameIsValid,
      lastNameIsValid,
      agentFullNameIsValid,
      showAgentsTable,
      handleShowFavorites,
      v$
    };
  }
});